import React from 'react';

const UnorderedListSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M9 18.5h11v-1H9v1zM9 11.5h11v1H9zM9 5.5h11v1H9z" />
        </g>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M4 5.5h2v1H4zM4 11.5h2v1H4zM4 17.5h2v1H4z" />
        </g>
    </svg>
);

UnorderedListSvg.displayName = 'UnorderedListSvg';
export default UnorderedListSvg;
